import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-more-info',
  templateUrl: './more-info.component.html',
  styleUrls: ['./more-info.component.scss']
})
export class MoreInfoComponent implements OnInit {
  journalExpanded = false;
  buttonText = 'Show Journal';
  sentenceJournalExpanded = false;
  sentenceJournalButtonText = 'Show Journal';
  
  constructor() { }
  
  ngOnInit(): void {
    // console.log('Component initialized, journalExpanded:', this.journalExpanded);
    window.scrollTo(0, 0);
  }
  
  toggleJournal(): void {
    console.log('Button clicked, current state:', this.journalExpanded);
    this.journalExpanded = !this.journalExpanded;
    this.buttonText = this.journalExpanded ? 'Hide Journal' : 'Show Journal';
    console.log('New state:', this.journalExpanded);
  }
  
  toggleSentenceJournal(): void {
    this.sentenceJournalExpanded = !this.sentenceJournalExpanded;
    this.sentenceJournalButtonText = this.sentenceJournalExpanded ? 'Hide Journal' : 'Show Journal';
  }
  
  downloadPowerWordJournal(): void {
    // Create a link to the PDF file
    const pdfUrl = 'assets/journals/Power_Word_Practice.pdf';
    this.downloadPdf(pdfUrl, 'Power-Word-Journal.pdf');
  }
  
  downloadSentenceJournal(): void {
    // Create a link to the PDF file
    const pdfUrl = 'assets/journals/One_Sentence_Journal.pdf';
    this.downloadPdf(pdfUrl, 'One-Sentence-Journal.pdf');
  }
  
  private downloadPdf(pdfUrl: string, fileName: string): void {
    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = fileName;
    link.target = '_blank';
    
    // Append to the document, trigger click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
